import React from "react";
import { Box, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import { getMealSummaryCards } from "../mealIncidenciasUtils";

const colors = {
  total: "#004f7c",
  PENDIENTE: "#d94841",
  EN_REVISION: "#f39313",
  VALIDADA: "#008080",
  DESCARTADA: "#64748b",
};

const MealReviewSummary = ({ summary, loading }) => (
  <Grid container spacing={1.5} aria-label="Resumen operativo de incidencias">
    {getMealSummaryCards(summary).map((item) => (
      <Grid item xs={6} md={2.4} key={item.key}>
        <Paper
          variant="outlined"
          sx={{
            height: "100%",
            minHeight: 92,
            p: 1.75,
            borderRadius: 2,
            borderTop: `4px solid ${colors[item.key]}`,
            bgcolor: "background.paper",
          }}
        >
          {loading ? (
            <Box minHeight={48} display="flex" alignItems="center">
              <CircularProgress size={24} aria-label={`Cargando ${item.label}`} />
            </Box>
          ) : (
            <Typography variant="h4" fontWeight={900} color={colors[item.key]}>
              {new Intl.NumberFormat("es-VE").format(item.value)}
            </Typography>
          )}
          <Typography variant="body2" fontWeight={800} color="text.secondary">
            {item.label}
          </Typography>
        </Paper>
      </Grid>
    ))}
  </Grid>
);

export default MealReviewSummary;
